import { Grid, Paper, Stack, useMediaQuery, useTheme } from '@mui/material'

import { Activity } from 'react'

const AnimatedBackgroundLayout = ({ children, background }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Activity>
      {!isMobile && background}
      <Grid
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'end',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        <Paper
          square
          elevation={24}
          sx={{
            z: 100,
            width: { sm: '100%', md: '50%' },
            height: '100vh',
          }}
        >
          <Stack
            sx={{
              height: '100vh',
              justifyContent: 'center',
              p: 4,
            }}
          >
            {children}
          </Stack>
        </Paper>
      </Grid>
    </Activity>
  )
}

export default AnimatedBackgroundLayout
